export default "__VITE_ASSET__92224c99__"